var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.4142,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.3 16.7 1.4-1.4-3.7-3.7v-4.6h-2v5.4l4.3 4.3zm-3.3 5.3c-1.383 0-2.683-0.263-3.9-0.788s-2.275-1.237-3.175-2.137-1.612-1.958-2.137-3.175-0.788-2.517-0.788-3.9 0.263-2.683 0.788-3.9 1.237-2.275 2.137-3.175 1.958-1.613 3.175-2.138 2.517-0.787 3.9-0.787 2.683 0.262 3.9 0.787 2.275 1.238 3.175 2.138 1.612 1.958 2.137 3.175 0.788 2.517 0.788 3.9-0.263 2.683-0.788 3.9-1.237 2.275-2.137 3.175-1.958 1.612-3.175 2.137-2.517 0.788-3.9 0.788zm0-2c2.217 0 4.104-0.779 5.663-2.337 1.558-1.559 2.337-3.446 2.337-5.663s-0.779-4.104-2.337-5.663c-1.559-1.558-3.446-2.337-5.663-2.337s-4.104 0.779-5.662 2.337c-1.559 1.559-2.338 3.446-2.338 5.663s0.779 4.104 2.338 5.663c1.558 1.558 3.445 2.337 5.662 2.337z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClock);
export default __webpack_public_path__ + "static/media/ic-clock.70a1456c1165c3719a66ceb3a77c9bf5.svg";
export { ForwardRef as ReactComponent };